var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8346 14.0013C26.8346 21.0093 21.0219 26.8346 14.0013 26.8346C6.9933 26.8346 1.16797 21.0093 1.16797 14.0013C1.16797 6.98071 6.98071 1.16797 13.9887 1.16797C21.0093 1.16797 26.8346 6.98071 26.8346 14.0013ZM20.8755 14.0013C20.8755 14.7151 20.2968 15.2938 19.583 15.2938H15.2938V19.583C15.2938 20.2968 14.7151 20.8755 14.0013 20.8755C13.2875 20.8755 12.7088 20.2968 12.7088 19.583L12.7088 15.2938L8.41963 15.2938C7.7058 15.2938 7.12713 14.7151 7.12713 14.0013C7.12713 13.2875 7.7058 12.7088 8.41963 12.7088H12.7088V8.41964C12.7088 7.70581 13.2875 7.12714 14.0013 7.12714C14.7151 7.12714 15.2938 7.70581 15.2938 8.41964L15.2938 12.7088L19.583 12.7088C20.2968 12.7088 20.8755 13.2875 20.8755 14.0013Z",
    fill: "#7B5DF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.b41b1a9723045f87e8ff9d847bd80ede.svg";
export { ForwardRef as ReactComponent };